import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { notificationActions } from '../../notifications/actions/notification';
import {
  editOrganization,
  getOrganization,
  getOrganizationFeatureFlags,
  getPresigned,
  uploadAvatar,
} from '../api/organization';
import * as constants from '../constants/organizationActionTypes';

const { notificationAdd } = notificationActions;

export function* getOrganizationGen(action: any) {
  try {
    const result = yield call(getOrganization, action.organizationID);
    yield put({
      type: constants.ORGANIZATION_GET_SUCCEEDED,
      organization: result.data,
    });
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_GET_FAILED,
      message: e.message,
    });
  }
}

function* getOrganizationFeatureFlagsGen(action: any) {
  try {
    const result = yield call(
      getOrganizationFeatureFlags,
      action.organizationID,
    );
    yield put({
      type: constants.ORGANIZATION_GET_FEATURE_FLAGS_SUCCEEDED,
      featureflags: result.data,
    });
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_GET_FEATURE_FLAGS_FAILED,
    });
  }
}

export function* organizationInfoLoadedGen(action) {
  try {
    const result = yield call(getOrganization, action.organization.id);
    yield put({
      type: constants.ORGANIZATION_GET_SUCCEEDED,
      organization: result.data,
    });
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_GET_FAILED,
      message: e.message,
    });
  }
}

export function* getPresignedGen(action) {
  try {
    const result = yield call(getPresigned, action.file);

    yield put({
      type: constants.ORGANIZATION_GET_PRESIGNED_SUCCEEDED,
      presigned: result.data,
      file: action.file,
      organization: action.organization,
    });
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_GET_PRESIGNED_FAILED,
      error: e.message,
    });
  }
}

export function* uploadAvatarGen(action) {
  try {
    yield call(uploadAvatar, action.presigned, action.file);

    const payload = {
      updates: {
        avatar_url: action.presigned.download_url,
      },
    };
    yield put({
      type: constants.ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED,
      payload: payload,
      id: action.organization.id,
    });
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_UPLOAD_AVATAR_FAILED,
      error: e.message,
    });
  }
}

export function* editOrganizationGen(action) {
  try {
    const result = yield call(editOrganization, action.id, action.payload);
    const defaultNotification = {
      title: 'Saved',
      text: `Organization settings saved`,
      className: 'success',
      type: 'organizationSaved',
      icon: 'i-done',
      time: 3000,
    };

    yield put({
      type: constants.ORGANIZATION_EDIT_SUCCEEDED,
      organization: result.data,
    });
    yield put(notificationAdd(action.notification || defaultNotification));
  } catch (e: any) {
    yield put({
      type: constants.ORGANIZATION_EDIT_FAILED,
      error: e.message,
    });
  }
}

export const organization = [
  takeLatest(constants.ORGANIZATION_GET, getOrganizationGen),
  takeLatest(
    constants.ORGANIZATION_GET_FEATURE_FLAGS,
    getOrganizationFeatureFlagsGen,
  ),
  takeLatest(constants.ORGANIZATION_LOADED, organizationInfoLoadedGen),
  takeEvery(constants.ORGANIZATION_GET_PRESIGNED, getPresignedGen),
  takeEvery(constants.ORGANIZATION_EDIT, editOrganizationGen),
  takeEvery(constants.ORGANIZATION_GET_PRESIGNED_SUCCEEDED, uploadAvatarGen),
  takeEvery(
    constants.ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED,
    editOrganizationGen,
  ),
];
